import axios from 'axios';

/** Retry only the idempotent stream read, never mutations or application errors. */
export async function retryWorkoutStream<T>(read: () => Promise<T>): Promise<T> {
  for (let attempt = 0; ; attempt++) {
    try {
      return await read();
    } catch (error) {
      const retryable = axios.isAxiosError(error) && !axios.isCancel(error) && (
        (!error.response && ['ERR_NETWORK', 'ECONNABORTED', 'ETIMEDOUT', 'ECONNRESET', 'EAI_AGAIN', 'ENOTFOUND'].includes(error.code ?? ''))
        || [502, 503, 504].includes(error.response?.status ?? 0)
        // Older Vite proxies report an upstream socket failure as an empty 500.
        || (error.response?.status === 500 && error.response.data === '')
      );
      if (!retryable || attempt >= 2) throw error;
      await new Promise(resolve => setTimeout(resolve, 750 * 2 ** attempt));
    }
  }
}
